<ng-container *ngIf="!showAddCategoryForm">
    <div class="wrapper d-flex flex-column">
        <div class="new-category-wrapper d-flex flex-column justify-content-center align-items-center">
            <div class="image-wrapper">
                <img src="Illustration.png" />
            </div>
            <strong class="mb-2">{{ (categoryList && categoryList.length > 0) ? 'Select a Category/Product to view the
                details!' : 'Start building your Catalog!' }}</strong>
            <p class="mb-3">{{ (categoryList && categoryList.length > 0) ? 'Or, please click the button below to create
                new categories and products.' : 'There are no categories yet. Create one now to start organizing the
                catalog.' }}</p>
            <button nz-button nzType="primary" (click)="showAddCategoryForm = true; initAddForm();">New
                Category / Product</button>
        </div>
    </div>
</ng-container>
<app-confirm-popup *ngIf="showModal" [title]="'Reset Confirmation'" [message]="'Are your sure to revert the changes?'"
    [confirmText]="'Confirm'" [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="resetForm()"
    (cancel)="showModal =false"></app-confirm-popup>

<ng-container *ngIf="showAddCategoryForm">
    <div class="wrapper position-relative ">
        @if(isLoadingData){
        <app-spinner></app-spinner>
        }
        @else {
        <div class="header top-header-block d-flex row align-items-center">
            <div class="col-md-6">
                <h5 class="px-4 py-3">{{getTitle() | decodeSpecialChar}} </h5>
            </div>
            <div class="header-action-btn col-md-6 d-flex align-items-center justify-content-end">
                <button nz-button class="mr-10" nzType="default" type="button" (click)="showModal = true">Reset</button>
                <button class="mr-10" (click)="onCancel()" nz-button nzType="default">Cancel</button>
                <button nz-button nzType="primary" type="button" (click)="saveCategory()">Save
                </button>
            </div>
        </div>
        <div class="col-md-12 mb-2 mt-2 d-flex justify-content-end">
            <ng-container>
                <span class="px-2 toggleText">Category</span> <nz-switch [nzDisabled]="!isAddCategory"
                    (ngModelChange)="switchForm($event)" [(ngModel)]="addProdctSwitch"></nz-switch>
                <span class="px-2 toggleText">Product</span>
            </ng-container>
        </div>
        <form [formGroup]="addEditCategoryForm">
            <div class="add-category-form p-4 row g-3">
                @for(input of categoryFields; track input.label){
                @if(input.type == 'input' && input.required){
                <div [ngClass]="input.formControlName == 'categoryName' ? 'col-md-12' : 'col-md-6'"
                    class=" position-relative">
                    <label class="form-label">{{input.label}}
                        @if(getCtrlValue(input?.formControlName)?.errors?.required){
                        <span class="text-danger">*</span>
                        }</label>
                    @if(input.richTextEditor){
                    <app-rich-text-field formControlName="{{input['formControlName']}}" placeholder="" (paste)="onPaste($event)"
                        [toolbar]="toolbar"></app-rich-text-field>
                    }@else{
                    <input type="text" class="form-control" placeholder={{input?.placeholder}}
                        formControlName="{{input?.formControlName}}">
                    }

                    <span class="text-danger" *ngIf="(getCtrlValue(input?.formControlName)?.errors?.required && !addEditCategoryForm.get(input.formControlName)?.value &&  (addEditCategoryForm.get(input.formControlName)?.touched) ||
                        (getCtrlValue(input?.formControlName)?.errors?.required) && invalidForm)">
                        {{input?.label}} is required.
                    </span>
                    <!-- @if(input.label == 'Category Name'){ -->
                    <span class="text-danger" *ngIf="addEditCategoryForm.get(input.formControlName)?.value && 
                        getCtrlValue(input?.formControlName)?.errors?.maxlength">
                        Maximum characters allowed for {{input?.label}} is {{getCtrlValue(input?.formControlName)?.errors?.maxlength.requiredLength}}.
                    </span>
                    <!-- } -->
                </div>
                }
                @if(input.type == 'accordion' && addProdctSwitch){
                <div class="header border-bottom-0 d-flex px-2 col-md-12 align-items-center">
                    <div class="col-md-4 px-0">
                        Product Details
                    </div>
                    <div class="col-md-8 d-flex justify-content-end">
                        <ng-container>
                            @if(!isAddCategory){
                            <button nz-button nzType="primary" (click)="previewProduct()"
                                class="d-flex justify-content-center align-items-center mr-10" [nzSize]="'default'">
                                Preview
                            </button>
                        }
                            <button nz-button nzType="primary" (click)="prodctPanel = true"
                                class="d-flex justify-content-center align-items-centers" [nzSize]="'default'">
                                {{getApplyMasterCatalogText()}}
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div class="product-details-wrapper px-3" [ngClass]="toggleProdct ? 'py-2' : 'py-2'">
                    <div class="row">
                        <div (click)="toggleProductDetails()"
                            class="pointer-cursor d-flex m-0 col-md-11 align-items-center justify-content-between">
                            <ng-container>
                                <img class="expand-icon" [src]="toggleProdct ? 'arrow_up.png' : 'arrow_down.png'">
                            </ng-container>
                            <div *ngIf="selectedProdctId != ''"
                                class="d-flex justify-content-center align-items-center">
                                <span class="p-2">Selected Style: <span
                                        class="ant-tag font-sz-14">{{selectedProdctId}}</span>
                                </span>
                            </div>
                            <div *ngIf="selectedVersion != ''" class="d-flex justify-content-center align-items-center">
                                <span class="p-2">Selected Version: <span
                                        class="ant-tag font-sz-14">{{selectedVersion}}</span></span>
                            </div>
                        </div>
                        <div class="col-md-1 d-flex m-0 align-items-center">
                            <button [disabled]="disableStyleEditAccess()" nz-tooltip="Edit Style Details"
                                (click)="editMCVisible = true" nz-button nzType="default"
                                class="custom-no-bg-button d-flex align-items-center" [nzSize]="'default'">
                                <span nz-icon nzType="export"></span>
                            </button>
                        </div>
                    </div>
                    <div #productDetails class="add-catalog-form p-2 row">
                        @if(copiedProdctDetails &&
                        copiedProdctDetails.length > 0){
                        <ng-container *ngFor="let prodct of copiedProdctDetails">
                            <ng-container>
                                <nz-collapse class="search-panel mt-2 mb-2" cdkDrag
                                    style="background-color: #ffff;border-radius:5px;border-bottom: 1px solid #d9d9d9 !important;">
                                    <nz-collapse-panel #panelRef [nzExtra]="customExpandIcon" [nzHeader]="header"
                                        [nzShowArrow]="false" [nzActive]="activeProdctCollapse"
                                        (nzActiveChange)="prodct['expand'] = !prodct['expand']">
                                        <ng-template #header>
                                            <h5 class="mt-2 attriubte-header">{{prodct.displayName}}</h5>
                                        </ng-template>
                                        <div class="d-flex flex-wrap mt-2">
                                            <div></div>
                                            <div
                                                [ngClass]="prodct.displayName == 'Bullets' ? 'd-flex flex-column' : ''">
                                                @for(lot of prodct.attributeValues;track lot) {


                                                <ng-container>
                                                    <nz-tag [innerHTML]="lot.attributeValue"
                                                        class="m-1 text-wrap"></nz-tag>
                                                </ng-container>
                                                }
                                            </div>
                                            <ng-template #customExpandIcon>
                                                <img class="expand-icon"
                                                    [src]="!prodct['expand'] ? 'arrow_up.png' : 'arrow_down.png'">
                                            </ng-template>
                                        </div>
                                    </nz-collapse-panel>
                                </nz-collapse>
                            </ng-container>

                        </ng-container>
                        }
                        @else{
                        <div class="text-center">
                            <span class="mb-3 fs-12">No product details available!</span>
                        </div>
                        }
                    </div>
                </div>

                }
                @else if(input.type == 'dropdown' && input.required){
                <div class="col-md-6 mb-2 d-flex flex-column">
                    <label class="form-label">{{input.label}}
                        @if(getCtrlValue(input?.formControlName)?.errors?.required){
                        <span class="text-danger">*</span>
                        }</label>
                    @if(input.label == 'Parent Category'){
                    <nz-select nzPlaceHolder="Select" nzSize="default" style="height: 35px !important;"
                        formControlName="{{input?.formControlName}}">
                        <nz-option *ngIf="!addProdctSwitch" nzLabel="Select" nzValue=0>
                            <span style="white-space: pre;">Select</span>
                        </nz-option>
                        @for(category of parentCategories; track category){
                        <nz-option [nzLabel]="category.categoryname | decodeSpecialChar" [nzValue]="category.seqno">
                            <span style="white-space: pre;">{{category.categoryname | decodeSpecialChar}}</span>
                        </nz-option>
                        }
                    </nz-select>
                    }
                    @else if(input.label == 'New Product'){
                    <nz-select nzPlaceHolder="Select" nzSize="default" style="height: 35px !important;"
                        formControlName="{{input?.formControlName}}">
                        @for(prodct of newProductList; track prodct){
                        <nz-option [nzLabel]="prodct.value" [nzValue]="prodct.id">
                        </nz-option>
                        }
                    </nz-select>
                    }
                    @else if(input.label == 'Gender' ){
                    <nz-select nzPlaceHolder="Select" nzSize="default" style="height: 35px !important;"
                        formControlName="{{input?.formControlName}}">
                        @for(gender of genderList; track gender){
                        <nz-option [nzLabel]="gender.value" [nzValue]="gender.id"></nz-option>
                        }
                    </nz-select>
                    }
                    @else if(input.label == 'CAT Level' ){
                    <nz-select nzPlaceHolder="Select" nzSize="default" style="height: 35px !important;"
                        formControlName="{{input?.formControlName}}">
                        @for(catLevel of catLevelList; track catLevel){
                        <nz-option [nzLabel]="catLevel.value" [nzValue]="catLevel.id"></nz-option>
                        }
                    </nz-select>
                    }
                    <span class="text-danger" *ngIf="(getCtrlValue(input?.formControlName)?.errors?.required && !addEditCategoryForm.get(input.formControlName)?.value &&  (addEditCategoryForm.get(input.formControlName)?.touched) ||
                        (getCtrlValue(input?.formControlName)?.errors?.required) && invalidForm)">
                        {{input?.label}} is required.
                    </span>
                </div>
                }
                @else if(input.type == 'textarea' && input.required){
                <div class="col-md-12 mb-2">
                    <label class="form-label">{{input.label}}
                        @if(getCtrlValue(input?.formControlName)?.errors?.required){
                        <span class="text-danger">*</span>
                        }</label>
                    <div class="input-group">

                        @if(input.richTextEditor){
                        <app-rich-text-field class="col-md-12 mb-2" [placeholder]="input['placeholder'] || ''" (paste)="onPaste($event)"
                            formControlName="{{input['formControlName']}}" [toolbar]="toolbar"></app-rich-text-field>
                        }@else{
                        <textarea [rows]="input?.rows" type="text" class="form-control"
                            placeholder={{input?.placeholder}} formControlName="{{input?.formControlName}}"></textarea>
                        }

                    </div>
                    <span class="text-danger" *ngIf="(getCtrlValue(input?.formControlName)?.errors?.required && !addEditCategoryForm.get(input.formControlName)?.value &&  (addEditCategoryForm.get(input.formControlName)?.touched) ||
                        (getCtrlValue(input?.formControlName)?.errors?.required) && invalidForm)">
                        {{input?.label}} is required.
                    </span>
                    <span class="text-danger" *ngIf="addEditCategoryForm.get(input.formControlName)?.value && 
                        getCtrlValue(input?.formControlName)?.errors?.maxlength">
                        Maximum characters allowed for {{input?.label}} is {{getCtrlValue(input?.formControlName)?.errors?.maxlength.requiredLength}}.
                    </span>
                </div>
                }
                @else if(input.type == 'checkbox' && input.required){
                <div class="col-md-6 mb-2">
                    @if(input.formControlName == 'ULClassified' && addProdctSwitch){
                    <div class="py-3">

                    </div>
                    }
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="{{input?.formControlName}}">
                        <label class="form-check-label">{{input.label}}
                            @if(getCtrlValue(input?.formControlName)?.errors?.required){
                            <span class="text-danger">*</span>
                            }</label>
                    </div>
                </div>
                }

                }
            </div>
            @if((!isAddCategory && addProdctSwitch) ) {
            <div class="header d-flex row align-items-center mb-2">
                <div class="col-md-9 px-4">
                    Associated Lots
                </div>
                <div class="col-md-3 mb-2">
                    <button
                        [ngStyle]="{'display': (!this.categoryData.styleId && addProdctSwitch) || !addProdctSwitch ? 'none': 'flex'}"
                        nz-button nzType="primary" (click)="lotPanel = true"
                        class=" justify-content-center align-items-center mr-10" [nzSize]="'default'">
                        Associate Lots
                    </button>
                </div>
            </div>
            <div class="add-catalog-form p-4 row">
                <ng-container>
                    @if(lots && lots.length > 0){
                    <div class="lot-keyword-section lots-block mt-2 mb-2 p-3">
                        <div class="d-flex flex-wrap mt-2 w-100 ">
                            @for(lot of lots;track lot) {
                            <ng-container>
                                <nz-tag [style.opacity]="$any(lot).hideOnWeb == 1 ? '0.5' : '1'"
                                [style.filter]="$any(lot).hideOnWeb == 1 ? 'grayscale(1)' : 'none'" class="m-1 text-wrap">{{lot.lotId}}</nz-tag>
                            </ng-container>
                            }
                        </div>
                    </div>
                    }
                    <div class="text-center" *ngIf="lots && lots.length == 0">
                        <span class="mb-3 fs-12">No lots have been associated yet!!!</span>
                    </div>
                </ng-container>
            </div>
            }
            <div class="header d-flex row align-items-center mb-2">
                <div class="col-md-9 px-4">
                    Internal Comments
                </div>
            </div>
            <div class="add-catalog-form add p-4 row">
                <ng-container>
                    <app-rich-text-field formControlName="internalComments" placeholder="" (paste)="onPaste($event)"  [toolbar]="toolbar"></app-rich-text-field>
                     <span class="text-danger" *ngIf="addEditCategoryForm.get('internalComments')?.value && 
                        getCtrlValue('internalComments')?.errors?.maxlength">
                        Maximum characters allowed forInternal Comments is {{getCtrlValue('internalComments')?.errors?.maxlength.requiredLength}}.
                    </span>
                </ng-container>
            </div>
        </form>
        }
    </div>

</ng-container>
<nz-drawer [nzMaskClosable]="false" [nzWidth]="600" [nzVisible]="prodctPanel" nzTitle="Apply Style From Master Catalog"
    (nzOnClose)="prodctPanel = !prodctPanel" [nzKeyboard]="false">
    <ng-container *nzDrawerContent>
        @if(prodctPanel){
        <app-add-product-details [applyStyleAction]="true"
            (emitSelectedProduct)="passAttributes($event)"></app-add-product-details>
        }
    </ng-container>
</nz-drawer>
<nz-drawer [nzMaskClosable]="false" [nzWidth]="1000" [nzVisible]="lotPanel" nzTitle="Associate Lots"
    (nzOnClose)="lotPanel = !lotPanel; checkLotUpdate()" [nzKeyboard]="false">
    <ng-container *nzDrawerContent>
        <app-associate-lot [categoryData]="categoryData" [catalogId]="catalogId"
            (emitLotChange)="handleLotUpdate($event)"></app-associate-lot>
    </ng-container>
</nz-drawer>
<nz-drawer [nzMaskClosable]="false" [nzKeyboard]="false" [nzWidth]="1000" [nzVisible]="editMCVisible"
    nzTitle="Master Catalog" (nzOnClose)="editMCVisible = !editMCVisible">
    <ng-container *nzDrawerContent>
        @if(editMCVisible) {
        <app-master-catalog [selectedProdctId]="selectedProdctId" [selectedVersion]="selectedVersion"
            [showAsDrawer]="true" [openUpdateWindow]="editMCVisible"
            (dataSavedSuccessfully)="editMCVisible = !editMCVisible; getCategoryDetail()"></app-master-catalog>
        }
    </ng-container>
</nz-drawer>
<nz-modal (nzOnOk)="previewModal = false" [nzFooter]="modalFooter" (nzOnCancel)="previewModal = false" nzClosable
    nzCentered [nzWidth]="900" [(nzVisible)]="previewModal" [nzBodyStyle]="{ height: '550px', overflowY: 'hidden' }"
    [nzTitle]="''">
    <ng-container *nzModalContent>
        <app-catalog-preview [previewData]="previewData" [imageLoading]="imageLoading"></app-catalog-preview>
    </ng-container>
    <ng-template #modalFooter>
        <button nz-button (click)="previewModal = false" nzType="primary">OK</button>
    </ng-template>
</nz-modal>
<nz-modal (nzOnOk)="showMultiLotModal = false" [nzFooter]="multiModalFooter" (nzOnCancel)="showMultiLotModal = false"
    [nzMaskClosable]="false"  nzCentered [nzWidth]="600"
    [(nzVisible)]="showMultiLotModal" [nzBodyStyle]="{ overflowY: 'auto' }">
    <ng-container *nzModalContent>
        <div class="container custom-modal d-flex flex-column px-1 py-1">
            <div class="d-flex mb-3">
                <span class="quest-icon" nz-icon nzType="question-circle"></span>
                <b class="px-3">Multi-Lot Update</b>
            </div>
            <span class="content">
                Products with the same Style ID and Version are found in other categories. <br><br>
                Do you want to apply the changes to them as well?
            </span>
        </div>

    </ng-container>
    <ng-template #multiModalFooter>
        <button nz-button class="mr-10" (click)="showMultiLotModal = false"
            nzType="default">Cancel</button>
        <button nz-button class="mr-10" (click)="updateCategory(categoryPayload,false)" nzType="primary"> No</button>
        <button nz-button (click)="updateCategory(categoryPayload,true)" nzType="primary"> Yes</button>
    </ng-template>
</nz-modal>